import { render, staticRenderFns } from "./SystemNavItemList.vue?vue&type=template&id=544b685a&scoped=true&"
import script from "./SystemNavItemList.vue?vue&type=script&lang=js&"
export * from "./SystemNavItemList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "544b685a",
  null
  
)

export default component.exports